module.exports = __webpack_public_path__ + "media/application/assets/images/views/companies/amount_yen-85576262e175e5ce8551aa0e5a12d0b8.svg";